import withPrivateRoute from './withPrivateRoutes'
import CommonLayout from '../../../../Layout/CommonLayout'

const PrivateCommonLayout = withPrivateRoute(CommonLayout)

export default PrivateCommonLayout